import styled from 'styled-components';

export const Body = styled.div`
  display: grid;
  grid-template-columns: min-content 1fr;
  align-items: baseline;
`;
